<template>
  <base-container :isLoading="isLoading">
    <!-- <van-nav-bar title="水费充值" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
    <div class="artisan-container">
    <van-notice-bar left-icon="volume-o" :text="noticeInfo" />
      <h2 class="artisan-center">水费充值</h2>
      <WaterFee @water-confirm="waterConfirm"></WaterFee>
      <van-button class="artisan-btn" round type="info" block @click="rechargeQuery">下一步</van-button>
    </div>
  </base-container>
</template>
<script>
import WaterFee from "./Waterfee";
import { Toast } from "vant";
export default {
  components: {
    WaterFee,
  },
  data() {
    return {
      isLoading: false,
      info: {},
      noticeInfo:"如果欠费停水，请致电0722-3329578（上班时间），0722-3318118（下班后20：00以前）通知开水，24小时内开通。",
    };
  },
  methods: {
    waterConfirm(info) {
      this.info = info;
    },
    rechargeQuery() {
      if (this.info.waterNo) {
        let query = {
          waterNo: this.info.waterNo,
          groupName: this.info.groupName,
        };
        this.$router.push({ path: "/waterinfo", query });
      } else {
        Toast.fail("请填写客户代码！");
      }
    },
  },
};
</script>

<style>
</style>